// extracted by mini-css-extract-plugin
module.exports = {"item":"_base-table-footer_item_3fe4-"};